import { get, post } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory/pending_inventory";

export const fetchPendingInventoryList = (page) => {
  const url = `${BASE_URL}/?page=${page}`;
  return get(url);
};

export const fetchPendingInventoryDetail = (id) => {
  const url = `${BASE_URL}/${id}/`;
  return get(url);
};

export const addPendingToInventory = (id, data) => {
  const url = `${BASE_URL}/${id}/add_to_inventory/`;
  return post(url, data);
};
